import React, { MouseEventHandler } from 'react';
import Button from '@material-ui/core/Button';
import { useGoogleMap } from '@react-google-maps/api';
import { useNavigate } from 'react-router-dom';
import { AppPath } from 'AppRoutes';
// EMERGENCY(Rainviewer API): 雨トグル復旧時に下記 3 行と Button ブロックのコメントを外すこと。
// import { mdiWeatherPouring } from '@mdi/js';
// import Icon from '@mdi/react';
// import CloudOffIcon from '@material-ui/icons/CloudOff';
import Box from '@material-ui/core/Box';

interface Props {
  boxCount: Number;
  boxBounds: google.maps.LatLngBounds;
  toggleRain: () => void;
  isRainShow: boolean;
  toggleEqShow: () => void;
  isEqShow: boolean;
}

const MapControls = ({
  boxCount,
  boxBounds,
  toggleRain: _toggleRain,
  isRainShow: _isRainShow,
  toggleEqShow,
  isEqShow,
}: Props) => {
  const map = useGoogleMap();
  const navigate = useNavigate();

  const handleClick: MouseEventHandler = (e) => {
    e.stopPropagation();
    navigate(AppPath.Home);
    map?.fitBounds(boxBounds);
  };

  return (
    <Box display="grid" gridColumnGap={10} gridAutoFlow="column">
      {/*
      EMERGENCY(Rainviewer API): 雨トグル非表示。復旧後はコメント解除し、上記 import も戻すこと。
      <Button variant="contained" color="secondary" onClick={toggleRain}>
        {isRainShow ? (
          <Icon path={mdiWeatherPouring} size={1} />
        ) : (
          <CloudOffIcon />
        )}
      </Button>
      */}
      <Button variant="contained" color="default" onClick={toggleEqShow}>
        {isEqShow ? '地震 ON' : '地震 OFF'}
      </Button>
      <Button
        disabled={boxCount === 0}
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        全表示
      </Button>
    </Box>
  );
};

export default MapControls;
